import {last} from 'remeda'
import {QuestionBounds, QuestionHardBounds} from '../forecast/question'
import {ForecastDrawn} from '../forecast/forecastTypes'
import {Dist} from './distributions'
import {doSafe} from '../promise'
import {createMonotoneInterpolator} from './monotoneCubic'
import {O} from 'ts-toolbelt'

export namespace DistDrawn {
  export const cfgToPdf = ({
    points,
    hardBounds,
    tails
  }: O.Optional<Pick<ForecastDrawn, 'tails' | 'hardBounds'>, 'hardBounds'> & {
    points: Pick<ForecastDrawn['points'][number], 'x' | 'p'>[]
  }): Dist.PdfForAgg => ({
    type: 'drawn',
    getP: x =>
      inHardBounds(x, hardBounds) ? createMonotoneInterpolator(points.map(p => ({x: p.x, y: p.p}))).getY(x) : 0,
    bounds: [hardBounds?.min ?? points[0]?.x ?? 0, hardBounds?.max ?? last(points)?.x ?? 0],
    ...doSafe(tails, t => ({
      left: doSafe(t.left?.pct, p => ({pct: p / 100, mode: hardBounds?.min != null ? 'bound' : 'tail'})),
      right: doSafe(t.right?.pct, p => ({pct: p / 100, mode: hardBounds?.max != null ? 'bound' : 'tail'}))
    }))
  })

  const inHardBounds = (x: number, bounds?: QuestionHardBounds) =>
    (bounds?.min == null || x >= bounds.min) && (bounds?.max == null || x <= bounds.max)
}
